export enum Quarters {
    FullYear,
    First,
    Second,
    Third,
    Fourth
}